// MARCA | 12/05/2026 | Gift card modal controller – card selection, pill prefill, character count, add dispatch, and reset handling

/**
 * Update the character count display for a given message block.
 * @param {HTMLElement} block
 */
function updateCharCount(block) {
  var textarea = /** @type {HTMLTextAreaElement | null} */ (
    block.querySelector('[data-giftcard-textarea]')
  );
  var countEl = block.querySelector('[data-giftcard-char-count]');
  if (!textarea || !countEl) return;
  var max = parseInt(block.dataset.maxChars || '250', 10);
  countEl.textContent = textarea.value.length + '/' + max + ' Characters used';
}

// MARCA | 12/05/2026 | Card type selection – highlight active card and track selected variant
document.addEventListener('click', function (e) {
  var card = /** @type {HTMLButtonElement | null} */ (
    /** @type {HTMLElement} */ (e.target).closest('.giftcard-modal__card')
  );
  if (!card) return;

  var container = card.closest('[data-giftcard-cards]');
  if (!container) return;

  container.querySelectorAll('.giftcard-modal__card').forEach(function (c) {
    c.classList.remove('giftcard-modal__card--active');
  });
  card.classList.add('giftcard-modal__card--active');
});

// MARCA | 12/05/2026 | Pill button click – prefill the textarea with a preset message
document.addEventListener('click', function (e) {
  var pill = /** @type {HTMLButtonElement | null} */ (
    /** @type {HTMLElement} */ (e.target).closest('.giftcard-message__pill')
  );
  if (!pill) return;

  var block = /** @type {HTMLElement | null} */ (pill.closest('[data-giftcard-message-block]'));
  if (!block) return;

  var textarea = /** @type {HTMLTextAreaElement | null} */ (
    block.querySelector('[data-giftcard-textarea]')
  );
  if (!textarea) return;

  var message = pill.dataset.presetMessage || '';
  textarea.value = message;
  updateCharCount(block);

  block.querySelectorAll('.giftcard-message__pill').forEach(function (p) {
    p.classList.remove('giftcard-message__pill--active');
  });
  pill.classList.add('giftcard-message__pill--active');

  textarea.focus();
});

// MARCA | 12/05/2026 | Character count live update on textarea input
document.addEventListener('input', function (e) {
  var textarea = /** @type {HTMLTextAreaElement | null} */ (
    /** @type {HTMLElement} */ (e.target).closest('[data-giftcard-textarea]')
  );
  if (!textarea) return;

  var block = /** @type {HTMLElement | null} */ (textarea.closest('[data-giftcard-message-block]'));
  if (!block) return;

  var currentValue = textarea.value;
  updateCharCount(block);

  block.querySelectorAll('.giftcard-message__pill').forEach(function (p) {
    if (/** @type {HTMLElement} */ (p).dataset.presetMessage !== currentValue) {
      p.classList.remove('giftcard-message__pill--active');
    }
  });
});

// MARCA | 12/05/2026 | ADD button – read selected card + message, dispatch upsell:toggle, close modal
document.addEventListener('click', function (e) {
  var button = /** @type {HTMLButtonElement | null} */ (
    /** @type {HTMLElement} */ (e.target).closest('[data-giftcard-add-button]')
  );
  if (!button || button.disabled) return;

  var block = /** @type {HTMLElement | null} */ (button.closest('[data-giftcard-message-block]'));
  if (!block) return;

  var textarea = /** @type {HTMLTextAreaElement | null} */ (
    block.querySelector('[data-giftcard-textarea]')
  );
  var messageText = textarea ? textarea.value.trim() : '';

  if (!messageText) {
    if (textarea) textarea.focus();
    var inputArea = block.querySelector('.giftcard-message__input-area');
    if (inputArea) inputArea.classList.add('giftcard-message__input-area--error');
    setTimeout(function () {
      if (inputArea) inputArea.classList.remove('giftcard-message__input-area--error');
    }, 2000);
    return;
  }

  var activeCard = /** @type {HTMLElement | null} */ (
    block.querySelector('.giftcard-modal__card--active')
  );
  if (!activeCard) return;

  var variantId = parseInt(activeCard.dataset.cardVariantId || '0', 10);
  var productTitle = block.dataset.productTitle || '';

  document.dispatchEvent(
    new CustomEvent('upsell:toggle', {
      detail: {
        type: 'giftcard',
        selected: true,
        variantId: variantId,
        productTitle: productTitle,
        message: messageText,
      },
    })
  );

  var dialog = /** @type {HTMLDialogElement | null} */ (block.closest('dialog'));
  if (dialog) dialog.close();
});

// MARCA | 12/05/2026 | Close modal button
document.addEventListener('click', function (e) {
  var closeBtn = /** @type {HTMLElement | null} */ (
    /** @type {HTMLElement} */ (e.target).closest('[data-giftcard-modal-close]')
  );
  if (!closeBtn) return;

  var dialog = /** @type {HTMLDialogElement | null} */ (closeBtn.closest('dialog'));
  if (dialog) dialog.close();
});

/**
 * Fully reset the modal state (card selection, textarea, pills, button).
 */
function resetModal() {
  var block = /** @type {HTMLElement | null} */ (
    document.querySelector('[data-giftcard-message-block]')
  );
  if (!block) return;

  var textarea = /** @type {HTMLTextAreaElement | null} */ (
    block.querySelector('[data-giftcard-textarea]')
  );
  var button = /** @type {HTMLButtonElement | null} */ (
    block.querySelector('[data-giftcard-add-button]')
  );
  var textEl = block.querySelector('[data-giftcard-add-text]');

  if (textarea) {
    textarea.value = '';
    textarea.readOnly = false;
  }
  if (textEl) textEl.textContent = 'ADD';
  if (button) {
    button.classList.remove('giftcard-message__add-button--added');
    button.disabled = false;
  }

  block.querySelectorAll('.giftcard-message__pill').forEach(function (p) {
    p.classList.remove('giftcard-message__pill--active');
  });

  // MARCA | 12/05/2026 | Re-select the first card as default
  var cards = block.querySelectorAll('.giftcard-modal__card');
  cards.forEach(function (c, i) {
    c.classList.toggle('giftcard-modal__card--active', i === 0);
  });

  updateCharCount(block);
}

// MARCA | 12/05/2026 | Full form reset after coordinator successfully adds to cart
document.addEventListener('upsell:reset', resetModal);

// MARCA | 12/05/2026 | Reset modal when the giftcard-upsell block deselects externally
document.addEventListener('upsell:toggle', function (e) {
  var d = /** @type {CustomEvent} */ (e).detail;
  if (!d || d.type !== 'giftcard') return;
  if (d.selected) return;

  resetModal();
});
